/** Mirrors backend `Sestek.AgenticCX.Enums.PhoneNumberDisplayFormat`. */
export enum PhoneNumberDisplayFormat {
  International = 1,
  Local = 2,
  DigitsOnly = 3,
}
